<template>
    <p class="small_header" v-html="formattedTitle"></p>
</template>

<script>
import { setTimerMixin } from '../mixins/setTimerMixin';

export default {
    mixins: [setTimerMixin],
    props: {
        header: {},
        timerEndtime: {},
    },
    computed: {
        formattedTitle() {
            if (!this.timerEndtime) {
                return this.header.replace('{placeholder}', this.$t('sales.soon'));
            }

            return this.replacePlaceholderBasedOnTimer(this.header, this.$t('sales.soon'), this.$t('sales.tonight'));
        },
    },
};
</script>
